import { z } from "zod";

export const rechargeSchema = z.object({
  value: z.number().min(50, "O valor mínimo para recarga é de R$ 50,00"),
});

export type RechargeSchema = z.infer<typeof rechargeSchema>;
